module.exports = __webpack_public_path__ + "img/pos-stock-small.5f7ea895.jpg";